import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { httpTranslateLoader } from '../../http-translate-loader';
import {
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { ConnectionStatusComponent } from './components/connection-status/connection-status.component';
import { TermsAndConditionsPageComponent } from './pages/terms-and-conditions-page/terms-and-conditions-page.component';
import { PrivacyPolicyPageComponent } from './pages/privacy-policy-page/privacy-policy-page.component';
import { AuthModule } from 'viewbid-shared-lib';
import { VerifyEmailPageComponent } from './pages/verify-email-page/verify-email-page.component';
import { PostLoginPageComponent } from './pages/post-login-page/post-login-page.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { FooterOneComponent } from './components/footer/footer-one/footer-one.component';
import { AppFooterShellComponent } from './components/footer/app-footer-shell/app-footer-shell.component';
import { HeaderTwoComponent } from './components/header/header-two/header-two.component';
import { AppHeaderShellComponent } from './components/header/app-header-shell/app-header-shell.component';
import { BreadcrumbOneComponent } from './components/header/breadcrumb-one/breadcrumb-one.component';
import { HeaderTopBarComponent } from './components/header/header-top-bar/header-top-bar.component';
import { MenuBarComponent } from './components/header/menu-bar/menu-bar.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { RouterModule } from '@angular/router';
import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';
import { CarouselAuctionComponent } from './components/carousel-auction/carousel-auction.component';
import { CustomBidComponent } from './components/custom-bid/custom-bid.component';
import { SearchComponent } from './components/search/search.component';
import { LotJumpComponent } from './components/lot-jump/lot-jump.component';
import { SchedulerDialogComponent } from './components/scheduler-dialog/scheduler-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WatchlistButtonComponent } from './components/buttons/watchlist-button/watchlist-button.component';
import { AboutPageComponent } from './pages/about-page/about-page.component';
import { FaqPageComponent } from './pages/faq-page/faq-page.component';
import { LayoutComponent } from './components/layout/layout.component';
import { ContactUsPageComponent } from './pages/contact-us-page/contact-us-page.component';
import { UnsubscriptionPageComponent } from './pages/unsubscription-page/unsubscription-page.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { SiteMapPageComponent } from './pages/site-map-page/site-map-page.component';
import { ChatboxComponent } from './components/chatbox/chatbox.component';
import { NewsletterSubscriptionFormComponent } from './components/newsletter-subscription-form/newsletter-subscription-form.component';
import { MasqueradeBannerComponent } from './components/masquerade-banner/masquerade-banner.component';
import { BiddingInstructionDisplayComponent } from './components/bidding-instruction-display/bidding-instruction-display.component';
import { NewsSectionPageComponent } from './pages/news-section-page/news-section-page.component';
import { NewsArticlePageComponent } from './pages/news-article-page/news-article-page.component';
import { BackToTopComponent } from './components/back-to-top/back-to-top.component';
import { NiceSelectComponent } from './components/nice-select/nice-select.component';
import {
    VbAppFooterComponent,
    VbAppHeaderComponent,
    VbAuctionInfoBandComponent,
    VbAuctionRowComponent,
    VbLotCardComponent,
    VbPaginatorBarComponent,
    VbSelectComponent,
    VbGalleryComponent,
    VbBidPanelComponent,
    VbBidConfirmDialogComponent,
    VbBreadcrumbComponent,
    VbSpecRowComponent,
    VbChipComponent,
    VbIconButtonComponent,
    VbDialogComponent,
    VbToastComponent,
    VbButtonComponent,
    VbIconComponent,
    VbTotalsComponent,
    VbToggleChipComponent,
    ContactUsComponent,
    VbNewsListComponent,
    VbNewsArticleComponent,
    VbNewsletterCardComponent,
    VbPageHeaderComponent,
    VbDocumentListComponent,
    VbSpinnerComponent,
    VbSupportWidgetComponent,
    VbDatePipe,
    VbDateTimePipe,
    VbTimePipe,
} from '@viewbid/ui';

@NgModule({
    declarations: [
        ConnectionStatusComponent,
        LoginPageComponent,
        TermsAndConditionsPageComponent,
        PrivacyPolicyPageComponent,
        VerifyEmailPageComponent,
        PostLoginPageComponent,
        FooterOneComponent,
        AppFooterShellComponent,
        HeaderTwoComponent,
        AppHeaderShellComponent,
        BreadcrumbOneComponent,
        HeaderTopBarComponent,
        MenuBarComponent,
        NotificationsComponent,
        NotFoundPageComponent,
        CarouselAuctionComponent,
        CustomBidComponent,
        SearchComponent,
        LotJumpComponent,
        SchedulerDialogComponent,
        WatchlistButtonComponent,
        AboutPageComponent,
        FaqPageComponent,
        LayoutComponent,
        ContactUsPageComponent,
        UnsubscriptionPageComponent,
        ConfirmationDialogComponent,
        SiteMapPageComponent,
        ChatboxComponent,
        NewsletterSubscriptionFormComponent,
        MasqueradeBannerComponent,
        BiddingInstructionDisplayComponent,
        NewsSectionPageComponent,
        NewsArticlePageComponent,
        BackToTopComponent,
        NiceSelectComponent,
    ],
    exports: [
        ConnectionStatusComponent,
        FooterOneComponent,
        AppFooterShellComponent,
        HeaderTwoComponent,
        AppHeaderShellComponent,
        BreadcrumbOneComponent,
        HeaderTopBarComponent,
        MenuBarComponent,
        CarouselAuctionComponent,
        CustomBidComponent,
        SearchComponent,
        LotJumpComponent,
        WatchlistButtonComponent,
        VbAuctionInfoBandComponent,
        VbLotCardComponent,
        VbPaginatorBarComponent,
        VbSelectComponent,
        VbGalleryComponent,
        VbBidPanelComponent,
        VbBidConfirmDialogComponent,
        VbBreadcrumbComponent,
        VbSpecRowComponent,
        VbChipComponent,
        VbIconButtonComponent,
        VbDialogComponent,
        VbToastComponent,
        VbButtonComponent,
        VbIconComponent,
        VbTotalsComponent,
        VbToggleChipComponent,
        VbDocumentListComponent,
        ContactUsComponent,
        NewsletterSubscriptionFormComponent,
        MasqueradeBannerComponent,
        BiddingInstructionDisplayComponent,
        BackToTopComponent,
        NiceSelectComponent,
        VbDatePipe,
        VbDateTimePipe,
        VbTimePipe,
    ],
    imports: [
        RouterModule,
        CommonModule,
        AuthModule,
        NgxSliderModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: httpTranslateLoader,
                deps: [HttpClient],
            },
        }),
        FormsModule,
        ReactiveFormsModule,
        VbAppFooterComponent,
        VbAppHeaderComponent,
        VbAuctionInfoBandComponent,
        VbLotCardComponent,
        VbAuctionRowComponent,
        VbPaginatorBarComponent,
        VbSelectComponent,
        VbGalleryComponent,
        VbBidPanelComponent,
        VbBidConfirmDialogComponent,
        VbBreadcrumbComponent,
        VbSpecRowComponent,
        VbChipComponent,
        VbIconButtonComponent,
        VbDialogComponent,
        VbToastComponent,
        VbButtonComponent,
        VbIconComponent,
        VbTotalsComponent,
        VbToggleChipComponent,
        ContactUsComponent,
        VbNewsListComponent,
        VbNewsArticleComponent,
        VbNewsletterCardComponent,
        VbPageHeaderComponent,
        VbDocumentListComponent,
        VbSpinnerComponent,
        VbSupportWidgetComponent,
        VbDatePipe,
        VbDateTimePipe,
        VbTimePipe,
    ],
    providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class SharedModule {}
